import { cn } from '@/lib/cn';
import type { HealthCheck } from '@innermate/shared';

interface HealthBadgeProps {
  data: HealthCheck | undefined;
  isLoading: boolean;
}

export function HealthBadge({ data, isLoading }: HealthBadgeProps) {
  if (isLoading || !data) {
    return <Pill dot="muted" label="확인 중…" />;
  }

  if (data.status === 'ok') {
    const ms = data.latencyMs;
    return <Pill dot="ok" label={ms != null ? `정상 · ${ms}ms` : '정상'} />;
  }

  if (data.status === 'skipped') {
    return <Pill dot="muted" label={data.message ?? '미설정'} />;
  }

  return (
    <Pill
      dot="error"
      label={data.message ? truncate(data.message, 60) : '오류'}
      title={data.message ?? undefined}
    />
  );
}

function Pill({
  dot,
  label,
  title,
}: {
  dot: 'ok' | 'error' | 'muted';
  label: string;
  title?: string;
}) {
  return (
    <span title={title} className="inline-flex items-center gap-1.5 text-xs text-foreground-muted">
      <span
        className={cn(
          'size-1.5 rounded-full',
          dot === 'ok' && 'bg-[hsl(142_71%_45%)]',
          dot === 'error' && 'bg-destructive',
          dot === 'muted' && 'bg-foreground-muted/50',
        )}
        aria-hidden
      />
      <span className="truncate max-w-[16rem]">{label}</span>
    </span>
  );
}

function truncate(s: string, n: number) {
  return s.length <= n ? s : `${s.slice(0, n - 1)}…`;
}
